import React from 'react';
import { Container } from 'reactstrap';
import { DashboardPageHeader, ComingSoonCard, DeptModulesGrid } from '../../Components/Common/DashboardKit';

/**
 * Information Technology landing page.
 *
 * Owner (2026-10-05): the department pages show MODULES, one card per module, the same
 * cards as General SS White (DeptLandingSections); the admin screens live inside the
 * Admin module. The route is gated by dept.it in allRoutes.js.
 */
const MODULES = ["admin", "support", "orgchart", "app-visitors", "kpi"];

const IT = () => {
    document.title = "SSW Technologies Dashboard";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <DashboardPageHeader
                        icon="ri-server-line"
                        eyebrow="Infrastructure"
                        title="Information Technology"
                        subtitle="Systems, accounts, and infrastructure"
                        tone="violet"
                        breadcrumb={[
                            { label: "Dashboards", to: "/" },
                            { label: "Information Technology" },
                        ]}
                    />

                    <DeptModulesGrid ids={MODULES} dept="all" title="IT modules" icon="ri-shield-user-line" />

                    <ComingSoonCard
                        compact
                        icon="ri-server-line"
                        title="More for IT later"
                        message="Ideas for later: account provisioning requests, license tracking and a system health view. The modules above are live today."
                        tone="primary"
                    />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default IT;
